import { Button, Popover, SxProps, Theme } from "@mui/material";
import { CaseFormContext } from "contexts/CaseFormContext";
import { Form } from "generated/graphql";
import { FC, useContext } from "react";
import FormFieldProvider from "routes/lenses/lens/case/FormFieldProvider";
import { MemoFormFieldEditor } from "./FormFieldEditor";
import { usePopover } from "helpers/hooks/usePopover";
import { LaunchRounded } from "@mui/icons-material";

interface FormFieldPopoverProps {
  form: Form;
  fieldId: number;
  navigateToBlock: (intakeId: number, page: number, blockIndex: number | undefined | null) => void;
  hideLightbulb?: boolean;
  sx?: SxProps<Theme>;
}
const FormFieldPopover: FC<FormFieldPopoverProps> = ({ form, fieldId, hideLightbulb, sx }) => {
  const popover = usePopover();
  const caseForm = useContext(CaseFormContext);
  const field = form.fields.find((f) => f.id === fieldId);
  const responsesCount = caseForm.serverFieldValues.find((sv) => sv.fieldId === field?.id)?.valueGroups.length;

  return (
    <>
      <Button
        size="medium"
        onClick={(evt) => popover.onPopoverOpen(evt.currentTarget)}
        sx={{
          ...sx,
          whiteSpace: "nowrap",
          mx: 0.5,
          flexShrink: 0,
        }}
        startIcon={<LaunchRounded />}>
        {responsesCount} Response{responsesCount === 1 ? "" : "s"}
      </Button>
      <Popover
        open={popover.isOpen}
        anchorEl={popover.anchorEl}
        onClose={popover.onPopoverClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        sx={{ maxWidth: 1200 }}>
        {field && (
          <FormFieldProvider formField={field} form={form}>
            <MemoFormFieldEditor sx={{ mb: 0, mr: 1 }} hideLightbulb={hideLightbulb} />
          </FormFieldProvider>
        )}
      </Popover>
    </>
  );
};

export default FormFieldPopover;
